/** @typedef {import('../types/models').Transaction} Transaction */
/** @typedef {import('../types/api').PaginatedResponse} PaginatedResponse */
/** @typedef {import('../types/api').PaginationParams} PaginationParams */

import { API_LIMIT, instance } from '../config/api';

/**
 * @param {string | number} transactionId
 * @returns {Promise<import('../types/api').ApiResponse<Transaction>>}
 */
const fetchTransactionById = async (transactionId) => {
  const { data } = await instance.get(`dashboard/transaction/${encodeURIComponent(transactionId)}`);
  return data;
};

/**
 * @param {PaginationParams & { currency?: number }} params
 * @returns {Promise<PaginatedResponse<Transaction>>}
 */
const fetchTransactions = async ({ offset, searchQuery, status, dateFilter, currency }) => {
  const { from, to } = dateFilter;
  const { data } = await instance.get(
    `transaction?limit=${API_LIMIT}${offset ? '&offset=' + offset : ''}${
      searchQuery ? '&search_term=' + searchQuery : ''
    }${status ? '&status=' + status : ''}${from && to ? '&from=' + from + '&to=' + to : ''}${
      currency ? '&currency_id=' + currency : ''
    }`
  );
  return data;
};

/**
 * @param {string | number} transactionId
 * @returns {Promise<import('../types/api').ApiResponse<{ events: Array<Object> }>>}
 */
const fetchTransactionWebhookEvents = async (transactionId) => {
  const { data } = await instance.get(
    `dashboard/transaction/${encodeURIComponent(transactionId)}/webhook-events`
  );
  return data;
};

/**
 * @param {string | number} transactionId
 * @param {string} [eventId] Replays the transaction's latest webhook event when omitted.
 * @returns {Promise<import('../types/api').ApiResponse<void>>}
 */
const replayTransactionWebhookEvent = async (transactionId, eventId) => {
  const { data } = await instance.post(
    `dashboard/transaction/${encodeURIComponent(transactionId)}/webhook-events/replay`,
    eventId ? { event_id: eventId } : {}
  );
  return data;
};

export {
  fetchTransactionById,
  fetchTransactions,
  fetchTransactionWebhookEvents,
  replayTransactionWebhookEvent
};
